import { SPHERE_IDS, THRESH } from './spheres.js';
import { lowSpheres } from './balance.js';
import { seedHash } from './observer.js';
import { DEFAULT_LOCALE } from './locale.js';
import { domainCopy } from './i18n/index.js';
/**
 * слова для колеса: имя в родительном падеже («колесо баланса Кати») и
 * короткий вывод в три строки, как хокку, на образах книги. тексты — в i18n.
 */
const HUSH = /[гкхжшщч]$/i;
/**
 * родительный падеж имени по обычным правилам русского языка. редкие и
 * иностранные имена, которые не склоняются по правилам, остаются как есть.
 */
export function nameGenitive(raw, gender = null) {
    const name = raw.trim();
    if (!name || /\s/.test(name) || !/^[а-яё-]+$/i.test(name))
        return name;
    const low = name.toLowerCase();
    const cut = (n) => name.slice(0, name.length - n);
    if (low.endsWith('я'))
        return `${cut(1)}и`; // Катя → Кати, Мария → Марии
    if (low.endsWith('а'))
        return HUSH.test(cut(1)) ? `${cut(1)}и` : `${cut(1)}ы`; // Ольга → Ольги, Маша → Маши, Анна → Анны
    if (low.endsWith('й'))
        return `${cut(1)}я`; // Андрей → Андрея
    if (low.endsWith('ь'))
        return gender === 'f' ? `${cut(1)}и` : `${cut(1)}я`; // Игорь → Игоря, Любовь → Любови
    if (/[оеиуюэы]$/i.test(low))
        return name; // Марко, Мари — не склоняются
    return `${name}а`; // Иван → Ивана
}
/** вывод по колесу: три строки, образы паутины; про деньги — только если просели деньги */
export function wheelHaiku(values, nm, seed, locale = DEFAULT_LOCALE) {
    const t = domainCopy(locale).haiku;
    const low = lowSpheres(values);
    const sorted = [...SPHERE_IDS].sort((a, b) => values[b] - values[a]);
    const top = sorted[0];
    const pick = (arr) => arr[seedHash(seed) % arr.length];
    if (low.length === 0)
        return pick(t.balanced({ top: nm(top) }));
    const weak = low[0];
    if (low.length === 1) {
        if (weak === 'dengi')
            return pick(t.money({ money: nm('dengi') }));
        return pick(t.one({ weak: nm(weak) }));
    }
    const second = low[1];
    const money = low.includes('dengi') && values.dengi < THRESH;
    return pick(t.many({ weak: nm(weak), second: nm(second), money: money ? nm('dengi') : null, count: low.length }));
}
//# sourceMappingURL=words.js.map